import { Address, ModelObject } from '@cco/model';
import { InvoiceLineItem } from './invoice-line-item';
import { InvoiceTaxLineItem } from './invoice-tax-line-item';

export type InvoiceStatus = 'DRAFT' | 'POSTED' | 'REVERSED';

export interface Invoice extends ModelObject<number> {
  invoiceNumber?: string;
  status?: InvoiceStatus;
  customerId: number;
  projectId?: number;
  jobId?: number;
  deliverySlipIds?: number[];
  invoiceTermId?: number;
  billTo?: string;
  billToAddress?: Address;
  shipTo?: string;
  shipToAddress?: Address;
  lineItems?: InvoiceLineItem[];
  taxGroupId?: number;
  taxLineItems?: InvoiceTaxLineItem[];
  subtotal?: string;
  taxTotal?: string;
  total?: string;
  message?: string;
  systemTags?: string[];
  date: string;
  dueDate?: string;
  purchaseOrderNumber?: string;
}

export function invoiceComparer(a: Invoice, b: Invoice) {
  if (a == null || b == null)
    return 0;

  if (a.date == null || b.date == null)
    return 0;

  const dateSort = -a.date.localeCompare(b.date);
  if (dateSort !== 0)
    return dateSort;

  if (a.invoiceNumber == null || b.invoiceNumber == null)
    return 0;

  return -a.invoiceNumber.localeCompare(b.invoiceNumber);
}

